// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"loading_loadingWrapper__Tonac","loadingIcon":"loading_loadingIcon__DnGsz","rotation":"loading_rotation__OcnEq"};